import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { catchError, tap, map } from "rxjs/operators";
import { GlobalsService } from "./globals";
import { Observable, of, throwError } from "rxjs";
import { Documents } from "../models/documents-class";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable({
  providedIn: "root",
})
export class ExploreService {
  constructor(private http: HttpClient, private globals: GlobalsService) {}

  private handleError<T>(operation = "operation", result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  private header(): HttpHeaders {
    return new HttpHeaders({
      Authorization: "Bearer " + this.globals.user.token,
      Accept: "application/json",
      "Content-Type": "application/json",
    });
  }

  getDocuments(): Observable<Documents[]> {
    return this.http
      .get<Documents[]>(`${this.globals.apiUrl}/api/recurso`)
      .pipe(
        tap((Documents) => console.log("fetched Documents")),
        catchError(this.handleError("getDocuments", []))
      );
  }
  searchDocs(str: string): Observable<any> {
    var uri = `/api/recurso/all?criterio=${str}`;
    var res = encodeURI(uri);
    const url = `${this.globals.apiUrl}${res}`;
    return this.http.get(url, {
      headers: this.header(),
    });
  }
  getId(id: string): Observable<Documents[]> {
    const url = `${this.globals.apiUrl}/api/recurso/${id}/list`;
    return this.http.get<Documents[]>(url).pipe(
      tap((_) => console.log(`fetched documents id=${id}`)),
      catchError(this.handleError<Documents[]>(`getDocumentsById id=${id}`))
    );
  }
  addDocuments(documents: Documents): Observable<Documents[]> {
    const apiUrl = `${this.globals.apiUrl}/api/recurso`;
    return this.http.post<Documents[]>(apiUrl, documents, httpOptions).pipe(
      tap((c: Documents[]) => console.log(`added product w/ id=${c}`)),
      catchError(this.handleError<Documents[]>("addDocuments"))
    );
  }
  updateDocuments(id: string, documents: Documents): Observable<any> {
    const url = `${this.globals.apiUrl}/api/recurso/${id}/list`;
    return this.http.put(url, documents, httpOptions).pipe(
      tap((_) => console.log(`updated documents id=${id}`)),
      catchError(this.handleError<any>("updateDocuments"))
    );
  }

  deleteDocuments(id: string): Observable<Documents[]> {
    const url = `${this.globals.apiUrl}/api/recurso/${id}/list`;
    return this.http.delete<Documents[]>(url, httpOptions).pipe(
      tap((_) => console.log(`deleted documents id=${id}`)),
      catchError(this.handleError<Documents[]>("deleteDocuments"))
    );
  }

  getDocumentById(id: string): Observable<Documents> {
    const url = `${this.globals.apiUrl}/api/recurso/${id}`;
    return this.http.get<Documents>(url);
  }
  getUnnaprovedNew(): Observable<any> {
    const url = `${this.globals.apiUrl}/api/recurso/recurso-devuelto-nuevo`;
    return this.http.get(url, {
      headers: this.header(),
    });
  }
  getUnnaprovedMod(): Observable<any> {
    const url = `${this.globals.apiUrl}/api/recurso/recurso-devuelto-modificado`;
    return this.http.get(url, {
      headers: this.header(),
    });
  }

  getPermiso(id) {
    return this.http.get(
      `${this.globals.apiUrl}/api/permiso/${id}/verificar-permiso`,
      {
        headers: this.header(),
      }
    );
  }
}
